require('./products-container.scss')

module.exports = {
  template: require('./products-container.pug')()
  controller: require('./products-container.ctrl')
}
